



































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import PasswordInput from '@/modules/shared/components/shared/form/PasswordInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { UpdatePasswordRequestModelInAdmin } from '@/modules/user/models/user-request.model'
import { AdminUpdateUserPasswordUseCase } from '@/modules/user/use-cases/admin/admin-update-user-password.use-case'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    BaseButton,
    PasswordInput
  }
})
export default class AdminUserChangePasswordForm extends Vue {
  constructor(
    private readonly useCase: AdminUpdateUserPasswordUseCase
  ) {
    super()
  }

  @Prop({ required: true }) userId: number

  private newPassword: string = null

  private confirmPassword: string = null

  protected onSubmit() {
    const requestData: UpdatePasswordRequestModelInAdmin = {
      new_password: this.newPassword,
      new_password_confirmation: this.confirmPassword
    }

    this.useCase.execute(this.userId, requestData)
  }
}
